// LAYOUT
// ----------------------------------------------------------------------

import { PATH_DASHBOARD } from './routes/paths';

export const PATH_AFTER_LOGIN = PATH_DASHBOARD.general.app;

export const HOST_API_KEY =
  process.env.NODE_ENV !== 'production'
    ? process.env.REACT_APP_API_KEY || 'http://10.20.30.21:15280'
    : process.env.REACT_APP_API_KEY_PRODUCTION;

export const HEADER = {
  MOBILE_HEIGHT: 64,
  MAIN_DESKTOP_HEIGHT: 88,
  DASHBOARD_DESKTOP_HEIGHT: 92,
  DASHBOARD_DESKTOP_OFFSET_HEIGHT: 92 - 32,
};

export const NAVBAR = {
  BASE_WIDTH: 260,
  DASHBOARD_WIDTH: 280,
  DASHBOARD_COLLAPSE_WIDTH: 88,
  //
  DASHBOARD_ITEM_ROOT_HEIGHT: 48,
  DASHBOARD_ITEM_SUB_HEIGHT: 40,
  DASHBOARD_ITEM_HORIZONTAL_HEIGHT: 32,
};

export const ICON = {
  NAVBAR_ITEM: 22,
  NAVBAR_ITEM_HORIZONTAL: 20,
};

// SETTINGS
// Please remove `localStorage` when you set settings.
// ----------------------------------------------------------------------

export const defaultSettings = {
  themeMode: 'dark',
  themeDirection: 'rtl',
  themeColorPresets: 'cyan',
  themeLayout: 'horizontal',
  themeStretch: false,
};
